module.exports = __webpack_public_path__ + "img/珍珠母.62fc3504.jpg";